import axios from "@/plugins/axios";
// import * as example from "./example";

let url = "/api/console/points";

export const points = {
    // ...example,
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
}
